import { compact } from "lodash-es"
import { BenefitsPlan } from "@oysterhr/schema"
import { Maybe } from "graphql/jsutils/Maybe"
import { allCurrencies } from "@oysterhr/common"

export const EXTRA_CURRENCY = {
  currencyCode: "",
  countryCode: "",
  currencyName: "",
  currencyDecimalDigits: 0,
}

export const getBenefitPlanAvailableCurrencies = (plan?: Maybe<BenefitsPlan>) => {
  return [
    EXTRA_CURRENCY,
    ...compact(
      plan?.priceEstimate?.currencies.map(planCurrency => {
        return (
          allCurrencies.find(currency => currency.currencyCode === planCurrency.currencyCode) ||
          null
        )
      }),
    ),
  ]
}
